<template>
  <div v-show="tenants.length">
    <v-autocomplete
      dense
      :label="labels.selectCompany"
      :items="tenants"
      item-text="tenantName"
      return-object
      v-model="tenant"
      hide-details="auto"
      single-line
      flat
      :dark="theme"
      @change="changeTenant"
    >
      <template slot="selection" slot-scope="{ item }">
        <div class="font-weight-light text-caption">{{ item.tenantName }}</div>
      </template>
      <template slot="item" slot-scope="{ item }">
        <v-list-item-content>
          <v-list-item-title v-text="item.tenantName" class="font-weight-medium text-caption"></v-list-item-title>
        </v-list-item-content>
        <!-- <v-list-item-subtitle>{{ item.title }}</v-list-item-subtitle> -->
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import store from '@/store/store'
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
  props: ['theme'],
  data() {
    return {
      tenants: JSON.parse(localStorage.getItem('tenants'))
        ? JSON.parse(localStorage.getItem('tenants')).AvailableTenants
        : [],
      tenant: JSON.parse(localStorage.getItem('tenants'))
        ? JSON.parse(localStorage.getItem('tenants')).SelectedTenant
        : undefined,
      labels: {
        selectCompany: translate('Select company', 'pages.login')
      }
    }
  },
  methods: {
    changeTenant(){
          store.dispatch('user/changeTenant', {
           tenantId : this.tenant.tenantId,
           refreshToken : JSON.parse(localStorage.getItem('user')).refreshToken
        })
      }
    }
}
</script>

<style scoped>
</style>
